const PropTypes = require('prop-types');
// @vendors
const React = require('react');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ local
const { BrokerAdvancedSearchETFsResultsRow } = require('./etfsResultsRow');

class BrokerAdvancedSearchETFsResultsTable extends React.Component {
    constructor(props) {
        super(props);

        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    handleProductSelect(product) {
        this.props.onHandleProductSelect(product);
    }

    tableHeaders() {
        const PREFIX = 'broker-searchResults';
        const nameLabel = formatText(`${PREFIX}NameLabel`);
        const categoryLabel = formatText(`${PREFIX}CategoryLabel`);
        const issuerLabel = formatText(`${PREFIX}IssuerAdministratorLabel`);
        const marketLabel = formatText(`${PREFIX}MarketLabel`);
        const currencyLabel = formatText(`${PREFIX}CurrencyLabel`);
        const dailyVariationLabel = formatText(`${PREFIX}DailyVariationLabel`);
        const ytdLabel = formatText(`${PREFIX}EtfsYtdRentabilityLabel`);

        return (
            <OKTableRow asHeader={true} className="broker-search-results__table-header">
                <OKTableCell
                    asHeader={true}
                    className="broker-search-results__table-first-column"
                    width="29%"
                >
                    {nameLabel}
                </OKTableCell>
                <OKTableCell asHeader={true} width="15%">
                    {marketLabel}
                </OKTableCell>
                <OKTableCell asHeader={true} width="10%">
                    {issuerLabel}
                </OKTableCell>
                <OKTableCell alignment="center" asHeader={true} width="10%">
                    {categoryLabel}
                </OKTableCell>
                <OKTableCell alignment="center" asHeader={true} width="6%">
                    {currencyLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="center"
                    asHeader={true}
                    width="15%"
                >
                    {dailyVariationLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="center"
                    asHeader={true}
                    width="8%"
                >
                    {ytdLabel}
                </OKTableCell>
                <OKTableCell asHeader={true} width="10%"/>
            </OKTableRow>
        );
    }

    tableRows(results) {
        const tableRows = results.map((result,index) => {
            const uniqueId = result.get('productKey');
            return this.props.isModal
                ? (<BrokerAdvancedSearchETFsResultsRow
                    key={uniqueId}
                    item={result}
                    isModal={this.props.isModal}
                    onHandleProductSelect={this.handleProductSelect}
                    onBuyClick={this.props.onHandleProductBuy}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}
                    watchlistEnabled={this.props.watchlistEnabled}
                  />)
                : <BrokerAdvancedSearchETFsResultsRow
                    key={uniqueId}
                    item={result}
                    onBuyClick={this.props.onHandleProductBuy}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}
                    watchlistEnabled={this.props.watchlistEnabled}
                />;
        });

        return tableRows;
    }

    render() {
        const { results} = this.props;

        const tableHeaders = this.tableHeaders();
        const tableRows = this.tableRows(results);

        /**
         * @horizontal-scroll
         *
         * The result table has a container with an horizontal scroll and the
         * inner content is set to a fix width according to its size in
         * desktop.
         */

        return (
            <div className="broker-search-results__table-wrapper" style={{ overflowX: 'auto' }}>
                <OKTable className="broker-search-results__table">
                    <thead>
                        {tableHeaders}
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                </OKTable>
            </div>
        );
    }
}

BrokerAdvancedSearchETFsResultsTable.propTypes = {
    deleteProductFromList: PropTypes.func,
    isModal: PropTypes.bool,
    onHandleProductBuy: PropTypes.func,
    onHandleProductSelect: PropTypes.func,
    onHandleWatchlistAdd: PropTypes.func,
    results: PropTypes.object,
    selectedType: PropTypes.string,
    watchlistEnabled: PropTypes.bool
};

module.exports = BrokerAdvancedSearchETFsResultsTable;

